// extracted by mini-css-extract-plugin
export default {"nav_icon":"nav_barcode_nav_icon__-7CpO","button":"nav_barcode_button__AAUmQ","search_icon":"nav_barcode_search_icon__JsHjy"};